import { Component, OnInit } from '@angular/core';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormGroup, FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';

import axios from 'src/app/Service/axios';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { OtherService } from 'src/app/Service/other.service';

import * as XLSX from 'xlsx';

import * as moment from 'moment';

import momentJalaali from 'moment-jalaali';

declare let $: any;

@Component({

  selector: 'app-checks-report',

  templateUrl: './checks-report.component.html',

  styleUrls: ['./checks-report.component.css']

})

export class ChecksReportComponent implements OnInit {

  list_Checks: [] = [];

  lstPassenger: any = [];

  check_Obj: any = {};

  searchModel: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    iDebit: new FormControl('0', Validators.required),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.searchModel.get('strEDate')?.setValue(momentJalaali().locale('fa').add(1, 'day').format('jYYYY/jMM/jDD'))

  }

  async searchChecks() {

    if (this.searchModel.invalid) return this._tooltip.showError('لطفا تاریخ شروع و پایان را مشحص کنید');

    this.check_Obj.iTotal = 0;

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_DebitCredit_Check_List`, this._otherService.stringNumberToNumber(this.searchModel.value))).data.toString());

    this._otherService.nonespinner()

    if (res.iResult == 0) return this._tooltip.showError(res.strError)

    this.list_Checks = res;

    this.list_Checks.forEach((el: any) => {

      this.check_Obj.iTotal += el.iCredit

    })

  }

  selectAllCheckBox() {

    if (this.list_Checks.length > 0 && (this.list_Checks.length != this.lstPassenger.length)) {

      this.lstPassenger = [];

      this.list_Checks.forEach((a: any) => {

        this.lstPassenger.push(a.iPassenger);

      })

      this._tooltip.showSuccess('همه دانش آموزان انتخاب شدند')

    }

    else {

      this.lstPassenger = [];

    }

  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) this.lstPassenger.push(item.iPassenger);

    else {

      this.lstPassenger.find((value: any) => {

        if (value === item.iPassenger) {

          const index = this.lstPassenger.indexOf(item.iPassenger);

          if (index !== -1) this.lstPassenger.splice(index, 1);

        }

      })
    }

  }

  isSelected(item: any): boolean {

    return this.lstPassenger.indexOf(item) !== -1;

  }

  message_Modal() {

    if (this.lstPassenger.length == 0) return this._tooltip.showError('لطفا دانش آموزان مورد نظر خود را انتخاب کنید');

    $('#sendMessage').modal('show')

  }

  async sendMessage(form: NgForm) {

    if (form.value.strMessage == '') return this._tooltip.showError('لطفا متن پیام را مشخص کنید');

    if (!form.value.bSendPush && !form.value.bSaveMessage) return this._tooltip.showError('لطفا نحوه ارسال پیام را مشخص کنید');

    form.value['iSystemUser'] = this.gurdService.decrypt(localStorage.getItem('ID')!);

    form.value['strSession'] = this.gurdService.decrypt(localStorage.getItem('Session')!);

    form.value['lstPassenger'] = this.lstPassenger;

    let res = JSON.parse((await axios.post(`School_Passenger_SendMessage`, form.value)).data.toString());

    if (res.iResult) {

      $('#sendMessage').modal('hide');

      return this._tooltip.showSuccess('پیام با موفقیت ارسال شد');
    }

    else return this._tooltip.showError(res.strError)


  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'گزارش چک ها.xlsx');

    }, 200);

  }

}
